import {
  appBgColor,
  boxShadow, min, primaryColor, primaryFont,
  secondaryFont, wMBold, wLight,
  wMedium, primaryHeadingColor, wELight, minWidthApp, maxTablet, maxMobile,
  backDropPersonality, wbSmartLayer, wBold,
  joinSession, scrollbar, maxWidth1300,
  textTruncateSnippet, retina, retinaOne,
  scrollbarTransparent, smMobile, midMobile,
  primaryBgColor, backgroundGreenLayer,
  SecondaryColor, midTablet, white,
  minExtraLargeScreen, minStandardScreen,
  greyColor,
  wMLight,
  minTablet,
  midWidthApp,
  maxWidth1170,
  maxWidth,
} from '../../Utils/utilsStyle';

const generalStyleCore = `
  body {
   overflow-x : hidden;
   &.onboarding {
    overflow-y: hidden;
   }
   .skiptranslate > {
    iframe.skiptranslate{
      display: none;
    }
   }
   .googleTranslateTile {
    display:none !important; 
   }
  }
  .languageTranslationGlobal {
    position: fixed;
    right: 130px;
    width: auto;
    top: 25px; 
    z-index: 4;
    @media all and (max-width: 1440px) and (min-width: 1414px) {
      right: 132px;
    }
    @media all and (max-width: 1414px) and (min-width: 1399px) {
      right: 122px;
    }
    @media all and (max-width: 1398px) and (min-width: 1388px) {
      right: 119px;
    }
    @media all and (max-width: 1398px) and (min-width: 1388px) {
      right: 112px;
    }
    @media all and (max-width: 1387px) and (min-width: 1366px) {
      right: 103px;
    }
    @media all and (max-width: 1366px) and (min-width: 1360px) {
      right: 97px;
    }
    @media all and (max-width: 1360px) and (min-width: 1350px) {
      right: 99px;
    }
    @media all and (max-width: 1350px) and (min-width: 1336px) {
      right: 93px;
    }
     @media all and (max-width: 1336px) and (min-width: 1330px) {
      right: 82px;
    }
    @media all and (max-width: 1335px) and (min-width: 1300px) {
      right: 72px;
    }
    @media all and (max-width: 1300px) and (min-width: 1290px) {
      right: 74px;
    }
    @media all and (max-width: 1291px) and (min-width: 1280px) {
      right: 68px;
    }
    @media all and (max-width: 1279px) and (min-width: 1121px) {
      right: 77px;
    } 
    @media all and (max-width: 1121px) and (min-width: 1100px) {
      right: 72px;
    }
    @media all and (max-width: 1099px) and (min-width: 1024px) {
      right: 68px;
    }
    @media all and (max-width: 1024px) {
      right: 64px;
    } 
    @media all and (max-width: 1023px) {
      /* top: 20px;
      width: 24px;
      right: 60px; */
      display: none;
    }
    @media all and (max-width:767px) {
      right: 40px;
    }
    .placeholder-flag {
      height: 28px;
      width: 28px;
      object-fit: cover;
      border-radius: 50%;
      &.inner {
        margin-right: 8px;
      }
    }
    .language-heading {
      padding: 10px 18px;
      padding-bottom: 0px;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: -0.792px;
      color: rgb(66, 75, 80);
      cursor: auto;
      text-align: left;
      font-family: ${secondaryFont};
    }
    .button-wrapper-t {
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 0px 6.512px rgba(0, 0, 0, 0.24);
      border-radius: 50%;
      .close-icon-svg {
        width: 32px;
        height: 32px;
      }

    }
    .ant-dropdown {
      overflow: hidden !important;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.102473) !important;
      border-radius: 10px !important;
      background-color: #ffffff !important;
      border: 1px solid #EcEcEc !important;
    }
    .ant-dropdown-menu-root {
      /* height: 100% !important; */
      margin: 5px 14px;
      padding: 0px !important;
      border: none !important;
      width: 225px !important;
      box-shadow: none !important;
      height: 370px !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      &::-webkit-scrollbar {
      width: 4px;
      border-radius:8px;
      }

      &::-webkit-scrollbar-thumb {
        background: #001760;
        border-radius: 12px;
      }

      &::-webkit-scrollbar-track {
      background: #CFDAE8;
      }
      &{
      scrollbar-face-color: #001760;
      border-radius: 12px;
      }
    }
    
    .ant-dropdown-menu-root .ant-dropdown-menu-item {
      padding: 5px 18px !important;
      .ant-dropdown-menu-title-content {
        flex: unset !important;
      }
      &:nth-child(2) {
        &:hover {
          background-color: transparent;
        }    
      }
      &:first-child {
        & input{
          &,
          &:focus,
          &:hover{
            border: none;
            box-shadow: none;
            outline: none;
          }
        }
      }
    }
    .ant-dropdown-menu-root .ant-dropdown-menu-item {
      .ant-dropdown-menu-title-content {
        .dropDown-flag {
          height: 28px;
          width: 28px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
    
    .ant-dropdown-menu-root .ant-dropdown-menu-item.selectedValue {
      background-color:rgb(30, 194, 82) !important;
      color: #fff !important;
      pointer-events: none !important;
      &:hover {
        background-color:rgb(30, 194, 82) !important;
        color: #fff !important;
      }
    }

    .ant-dropdown-menu-root .ant-dropdown-menu-item.Select.Language {
      display: none;
    }

    .widget-search-bar {
      margin: 5px 14px;
      background-color: #fff;
      background-image: none;
      border: 1px solid rgb(218, 218, 218);
      border-radius: 25px;
      color: rgba(0, 0, 0, .85);
      display: inline-flex;
      line-height: 1.5715;
      min-width: 0;
      font-size: 14px;
      padding: 6.5px 11px;
      position: relative;
      transition: all .3s;
      width: 90%;
      height: 32px;
    }
    .ant-input-prefix {
      margin-right: 8px;
      padding-right: 8px;
      border-right: 2px solid rgb(218, 218, 218);
      cursor: auto;
    }
    .search-global-icon-svg {
      height: 16px;

    }
    .empty-message {
      margin: 0px auto;
      padding: 10px;
      height: 70%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flagPlaceholder {
      height: 30px;
      width: 30px;
      border-radius: 50%;
      object-fit: cover;
    }
        
  }
  .allowCopy {
    user-select: text !important;
    -moz-user-select: text !important;
    .slick-slider,  .slick-slide  {
      user-select: text !important;
      -moz-user-select: text !important;
    }
    .slick-current {
      z-index: 999;
    }
  }
  .chatBubble {
    &.chatImage {
      width: 140px;
      border-radius: 50%;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 140px;
      }
    } 
    width: 140px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 140px;
    }
  }
  .h-fit {
    height: fit-content;
  }
  main {
   background-color: ${appBgColor}
  }
  /* @media all and (max-width: ${maxTablet}){
    .fc-widget-small {
      display: none !important;
    }
    .freshDesk-Bot {
      display: none !important;
    }
  } */
  .sales-sigma {
    display: flex;
    align-items: center;
    strong {
     font-size: 12px;
     font-weight: 400;
    }
  }
  .container-company-card {
    .download-profile-blue, .compare-companies-blue, .buyer-group-blue,.share-blue {
      line-height: 25px;
      svg {
        min-width:18px;
      }
    }
  }
  #onesignal-bell-container {
    margin-right: 14px;
    bottom: 30px !important;
    right: auto !important;
    left: 160px !important;
    margin-right: 14px;
    display: none;
  }
  #root {
    + {
      /* div {
        display:none;
      } */
    }
  }
  .affinity-search-widget {
    &.icon-mode {
      .search-field-text {
        max-width: 200px;
        font-weight: ${wBold};
        font-size: 16px;
        @media all and (max-width: 576px) and (min-width: ${midMobile}) {
          margin-top: 0px;
          margin-left: -24px;
        }
        @media all and (max-width: ${midMobile}) {
          max-width: 149px;
        }
        @media all and (max-width: ${smMobile}) {
         font-size: 12px;
         margin-left: -12px;
         margin-top: 8px;
        }
      }
      .ant-input-prefix {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #DADADA;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        svg {
          height: 14px !important;
        }
      }
      .input-dropdown-wrapper {
        @media all and (max-width: ${smMobile}) {
          display: none;
        }
      }
    }
  }
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .img-fluid {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
  .img-ranking {
    height: auto;
  }
  .ant-badge-count {
    cursor: pointer;
  }
  .tabsAppend {
    .header-wrapper {
      .left-side-wrap {
        max-width: 20%;
        .heading {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 20px;
        }
      }
      .right-side-wrap {
        max-width: 80%;
      }
    }
  }
    .header-wrapper{
      height: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bell-icon-primary {
        cursor: pointer;
      }
      .left-side-wrap {
        &.service-lines-left-wrap {
          max-width: 40%;
          @media all and (max-width: ${maxMobile}) {
            max-width: 60%;
          }
        }
        display: flex;
        align-items: center;
        @media all and (max-width: ${maxTablet}) {
        margin-left: 10px;
        }
        .back-icon-svg {
          margin-top: 2px;
          min-width: 20px;
        }
        .skeleton-box {
          @media all and (max-width: ${maxWidth1300}) {
            width: 150px;
            min-width: 150px;
          }
          @media all and (max-width: ${minWidthApp}) {
            margin-left: 10px;
          }
          @media all and (max-width: ${maxTablet}) {
            width: 140px;
            min-width: 140px;
          }
          @media all and (max-width: ${smMobile}) {
            width: 80px;
            min-width: 80px;
          }
        }
        svg {
          width: 23px;
          height: 25px;
          min-width: 16px;
          /* margin-top: 3px; */
          @media all and (max-width: ${maxWidth}) , ${retina} {
            width: 20px;
          }
        }
        .heading{
          &.guestUser{
            border:none;
          }
          font-size: 28px;
          line-height: 35px;
          font-family: ${secondaryFont};
          font-weight: ${wMBold};
          color: ${primaryHeadingColor};
          margin-bottom: 0px;
          border-left: 1px solid #DDDDDD;
          padding-left: 10px;
          margin-left: 10px;
          text-transform: initial;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            font-size: 28px;
            padding-left: 7px;
            margin-left: 7px;
          }
          @media all and (max-width: ${minWidthApp})
          {
            line-height:36px;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            word-wrap: break-word;
          }
        }
      }
      .right-side-wrap{
        display: flex;
        align-items: flex-start;
        margin-top: 3px;
        padding-right: 80px;
        @media all and (max-width: ${maxTablet}) {
          padding-right: 33px;
        }
        @media all and (max-width: ${maxMobile}) {
         padding-right: 0px;
        } */
        span {
          &:last-child {
            margin-right:0px;
          }
        }
        .iconModeActive {
          .filter-icon-dropdown {
            @media all and (max-width: ${maxWidth}) , ${retina} {
              width: 17px;
            }
          }
        }
      }
      .placeholder-flag {
        height: 28px;
        width: 28px;
        object-fit: cover;
        border-radius: 50%;
        &.inner {
          margin-right: 8px;
        }
      }
      .languageTranslationGlobal {
        position: absolute;
        right: 37px;
        width: auto;
        top: 8px; 
        .ant-dropdown {
          overflow: hidden !important;
          box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.102473) !important;
          border-radius: 10px !important;
          background-color: #ffffff !important;
          border: 1px solid #EcEcEc !important;
        }
        .ant-dropdown-menu-root {
          /* height: 100% !important; */
          margin: 5px 14px;
          padding: 0px !important;
          border: none !important;
          width: 225px !important;
          box-shadow: none !important;
          height: 370px !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          &::-webkit-scrollbar {
          width: 4px;
          border-radius:8px;
          }

          &::-webkit-scrollbar-thumb {
            background: #001760;
            border-radius: 12px;
          }

          &::-webkit-scrollbar-track {
          background: #CFDAE8;
          }
          &{
          scrollbar-face-color: #001760;
          border-radius: 12px;
          }
        }
        
        .ant-dropdown-menu-root .ant-dropdown-menu-item {
          padding: 5px 18px !important;
          &:nth-child(2) {
            &:hover {
              background-color: transparent;
            }    
          }
          &:first-child {
            & input{
              &,
              &:focus,
              &:hover{
                border: none;
                box-shadow: none;
                outline: none;
              }
            }
          }
        }
        .ant-dropdown-menu-root .ant-dropdown-menu-item {
          .ant-dropdown-menu-title-content {
            .dropDown-flag {
              height: 28px;
              width: 28px;
              object-fit: cover;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
        }
        
        .ant-dropdown-menu-root .ant-dropdown-menu-item.selectedValue {
          background-color:rgb(30, 194, 82) !important;
          color: #fff !important;
          pointer-events: none !important;
          &:hover {
            background-color:rgb(30, 194, 82) !important;
            color: #fff !important;
          }
        }

        .ant-dropdown-menu-root .ant-dropdown-menu-item.Select.Language {
          display: none;
        }

        .widget-search-bar {
          margin: 5px 14px;
          background-color: #fff;
          background-image: none;
          border: 1px solid rgb(218, 218, 218);
          border-radius: 25px;
          color: rgba(0, 0, 0, .85);
          display: inline-flex;
          line-height: 1.5715;
          min-width: 0;
          font-size: 14px;
          padding: 6.5px 11px;
          position: relative;
          transition: all .3s;
          width: 90%;
          height: 32px;
        }
        .ant-input-prefix {
          margin-right: 8px;
          padding-right: 8px;
          border-right: 2px solid rgb(218, 218, 218);
          cursor: auto;
        }
        .search-global-icon-svg {
          height: 16px;

        }
        .language-heading {
          padding: 10px 18px;
          padding-bottom: 0px;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: -0.792px;
          color: rgb(66, 75, 80);
          cursor: auto;
          text-align: left;
        }

        .empty-message {
          margin: 0px auto;
          padding: 10px;
          height: 70%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .flagPlaceholder {
          height: 30px;
          width: 30px;
          border-radius: 50%;
          object-fit: cover;
        }
        
      }
      .filterIconMode {
        .iconModeActive {
          svg {
            @media all and (max-width: ${maxWidth}) , ${retina} {
            width: 17px;
            }
          }
        }
      }
      .icon-mode {
        svg {
          @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 16px !important;
          }
        }
      }
      .bell-icon-primary {
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 18px;
        }
      }
    }
    .xiq-intelligence {
      /* margin-bottom: 13px; */
      text-align: center;
      svg {
        width:20px;
        height:20px;
        margin-left:10px;
        margin-top: 3px;
        cursor: pointer;
      }
      .text {
        display: inline-flex;
        background-color: #1EC252;
        color: white;
        padding: 1px 12px 2px 29px;
        font-weight:400;
        font-family: 'Roboto';
        font-size: 16px;
        letter-spacing: -0.4px;
      }
      .underline-text {
        margin-left: 3px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .container {
      margin-right: auto;
      margin-left: auto;
      width:100%;
      &.header-container {
        @media all and (max-width: ${maxTablet}) {
          padding: 0px;
        }
        @media all and (max-width: ${maxMobile}) {
          padding: 0px;
        }
      }
      @media all and (max-width: ${maxTablet}) {
        overflow-x: hidden;
        overflow-y: hidden;
      }
      &.o-revert {
        overflow-x: revert;
        overflow-y: revert;
      }
      @media all and (max-width: ${maxTablet}) {
        padding: 0px 30px;
      }
      @media all and (max-width: ${maxMobile}) {
        padding: 0px 15px;
      }
    }
    @media (min-width: 1023px) {
      .container {
       margin-right: auto;
       margin-left: auto;
       padding: 0px 40px;
       width:100%;
      }
    }
    @media all and (max-width: 1120px) and (min-width: 1023px) {
      .container {
        padding: 0px 20px;
      }
    }
    @media (min-width: 1280px) {
      .container {
       width: 1170px;
       padding: 0px 10px;
      }
    }

     @media (min-width: 1441px) {
      .container {
        width: 100%;
        padding: 0px 90px;
      }
    }

    .container-search {
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
      width:100%;
    }
    @media (min-width: 1024px) {
      .container-search {
      width: 950px;
      }
    }
    @media (min-width: 1320px) {
      .container-search {
      width: 1130px;
      }
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.redius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    .skeleton-box-transparent {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
       &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    .date-picker-dropdown, .time-picker-dropdown {
      font-family: ${primaryFont};
    }
  .p-relative {
    position: relative;
  }
  .border-0 {
    border: none;
  }
  .weight-900 {
    font-weight: 900;
  }
  .weight-500{
    font-weight: 500;
  }
  .weight-700{
    font-weight: 700;
  }
  .index-one {
    z-index: 1;
  }
  .indexZero {
    z-index: 0 !important;
  }
  .indexOne {
    z-index: 1;
  }
  .d-flex {
    display:flex;
  }
  .align-items-center{
    align-items: center;
  }
  .d-none {
    display:none;
  }
  .vHidden {
    visibility: hidden;
  }
  .dNone {
    display:none !important;
  }
  .justify-content-center {
    justify-content: center;
  }
  .justify-content-between {
    justify-content: space-between;
  }
   .justify-content-around {
    justify-content: space-around;
  }

  .justify-content-end, .justifyContentFlexEnd{
    justify-content: flex-end;
  }
  .flex-column{
    flex-direction: column;
  }
  .flex-row{
    flex-direction: row;
  }
  .radius-50 {
    border-radius: 50px !important;
  }
  .radius-25 {
    border-radius: 25px !important;
  }
  .radius-20 {
    border-radius: 20px !important;
  }
  .radius-10 {
    border-radius: 10px !important;
  }
  .width-100 {
    width:100%;
  }
  .w-50 {
    width: 50%;
    min-width: 50%;
  }
  .w-49 {
    width: 49%;
    min-width: 49%;
  }
  .w-100{
    width:100%;
    min-width:100%;
  }
  .w-70{
    width: 70%;
    min-width: 70%;
  }
  .w-80{
    width:80%;
    min-width:80%;
  }
  .w-90{
    width:90%;
    min-width:90%;
  }
  .text-center{
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .h-100 {
    height: 100%;
  }
  .pl-c-0 {
    padding-left: 0px;
  }
  .mt-c-0 {
    margin-top: 0px !important;
  }
  .mb-c-0 {
    margin-bottom: 0px !important;
  }
  .pb-4{
    padding-bottom: 1.5rem!important;
  }
  .pb-15{
    padding-bottom: 15px;
  }
  .px-3{
    padding-left: 1rem!important;
    padding-right: 1rem!important;
  }
  .align-self-center {
    align-self: center!important;
  }
  button{
    cursor: pointer;
  }
  .mb-0 {
    margin-bottom: 0!important;
  }
  .mx-c-negative {
    margin-right: -9px;
    margin-left: -9px;
  }
  .mr-0{
    margin-right: 0!important;
  }
  .pr-0 {
    padding-right: 0 !important;
  }
  .ml-0{
    margin-left: 0!important;
  }
  .ml-1 {
    margin-left: 10px;
  }
  .ml-2 {
    margin-left: 20px;
  }
  .ml-3 {
    margin-left: 30px;
  }
  .ml-4 {
    margin-left: 40px;
  }
  .ml-5 {
    margin-left: 50px;
  }
  .mr-1 {
    margin-right: 10px;
  }
  .mr-2 {
    margin-right: 20px;
  }
  .mr-3 {
    margin-right: 30px;
  }
  .mr-4 {
    margin-right: 40px;
  }
  .mr-5 {
    margin-right: 50px !important;
  }
  .mt-c-6 {
   margin-top: 6px;
  }
  .mt-c-10 {
   margin-top: 10px;
  }
  .mt-c-5 {
   margin-top: 5px;
  }
  .mt-c-15 {
   margin-top: 15px;
  }
  .mt-c-20 {
   margin-top: 20px;
  }
  .mtC20 {
    margin-top: 20px;
  }
  .mt-c-25 {
   margin-top: 25px;
  }
  .mt-c-30 {
   margin-top: 30px;
  }
  .mt-c-32 {
    margin-top: 32px;
  }
  .mt-c-40 {
   margin-top: 40px;
  }
  .mt-c-50 {
   margin-top: 50px;
  }
  .mb-c-5 {
    margin-bottom: 5px;
  }
  .mb-c-10 {
    margin-bottom: 10px;
  }
  .mbC10 {
    margin-bottom: 10px !important;
  }
  .mb-c-15 {
   margin-bottom: 15px;
  }
  .mb-c-20 {
   margin-bottom: 20px;
  }
  .mb-c-30 {
   margin-bottom: 30px;
  }
  .mb-c-40 {
   margin-bottom: 40px;
  }
  .mb-c-50 {
   margin-bottom: 50px;
  }
  .ml-c-5 {
    margin-left: 5px;
  }
  .ml-c-10 {
    margin-left: 10px;
  }
  .ml-c-15 {
   margin-left: 15px;
  }
  .ml-c-20 {
   margin-left: 20px;
  }
  .ml-c-30 {
   margin-left: 30px;
  }
  .ml-c-40 {
   margin-left: 40px;
  }
  .ml-c-50 {
   margin-left: 50px;
  }
  .m-x-y-c-0 {
    margin: 0 0 !important;
  }
  .px-0 {
    padding: 0px !important;
  }
  .px-0-res-1_5 {
    padding: 0px 90px !important;
    @media all and (max-width: ${maxWidth}) , ${retina} { 
      padding: 0px !important;
    }
  }
  .px-1 {
    padding: 0px 10px;
  }
  .px-2 {
    padding: 0px 20px;
  }
  .px-3 {
    padding: 0px 30px;
  }
  .px-4 {
    padding: 0px 40px;
  }
  .px-5 {
    padding: 0px 50px;
  }
  .py-1 {
    padding: 10px 0px;
  }
  .py-2 {
    padding: 20px 0px;
  }
  .py-3 {
    padding: 30px 0px;
  }
  .py-4 {
    padding: 40px 0px;
  }
  .py-5 {
    padding: 50px 0px;
  }
  .o-hidden, .oHidden {
    overflow: hidden;
  }
  .line-block {
    display: inline-block !important;
  }
  .h-auto {
    height: auto !important;
  }
  .headers-space {
    margin-bottom: 25px;
  }
  .box-shadow {
    box-shadow: ${boxShadow} !important;
  }
  .f-size-16 {
    font-size: 16px !important;
  }
  .account-activity-wrapper {
    padding-top: 24px;
    .heading-inner-page {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      .head-wrap {
        margin-right: auto;
      }
      .right-side-sub-header {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 16px;
        @media all and (max-width: ${maxMobile}) {
          gap: 8px;
        }
        .view-tabs {
          pointer-events: auto;
          .tabs-item {
            height: 30px;
            min-height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            @media all and (max-width: ${smMobile}) {
              height: 26px;
              min-height: 26px;
            }
          }
        }
        .filter-placeholder {
          min-width: unset;
          .tabs-wrapper.resolution-filter-popover {
            margin: 0 !important;
            justify-content: flex-start;
          }
          .global-tabs-item {
            width: 128px;
            height: 30px;
            min-height: 30px;
            > svg {
              height: 14px;
              width: 15px;
            }
            .filter-text {
              font-size: 14px;
            }
          }
          @media all and (max-width: ${maxTablet}) {
            min-width: 20px;
            .tabs-wrapper.iconModeActive {
              margin-left: 8px;
              .tabs-item {
                width: 30px !important;
                height: 30px !important;
                min-height: 30px !important;
                padding: 0 !important;
                border: 1px solid #DADADA !important;
                border-radius: 6px !important;
                background: #fff !important;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 0 !important;
                svg {
                  width: 14px;
                  height: 14px;
                }
              }
              @media all and (max-width: ${smMobile}) {
                .tabs-item {
                  height: 26px !important;
                  min-height: 26px !important;
                  width: 26px !important;
                }
              }
            }
          }
          @media all and (max-width: ${smMobile}) {
            margin-left: 6px;
          }
        }
      }
    }
  }
  .comment-wrapper-area {
    &.highlight {
      .text-area-notes {
        box-shadow: ${primaryColor} 0px 0px 0px 1px !important;
        border-color: ${primaryColor} !important;
      }
    }
  }
  .fStructure {
    display: flex;
    align-items: center;
    @media all and (max-width: ${maxTablet}) {
      padding: 0px 30px 0px 0px;
    }
     @media all and (max-width: ${maxMobile}) {
      padding: 0px 10px 0px 0px;
    }
  }
  .toaster-wrapper{
    min-width: 320px;
    position: fixed;
    left: 50%;
    top: 80px;
    z-index: 9999;
    transform: translateX(-50%);
    border-radius: 0px 0px 8px 8px;
    padding: 10px 40px 10px 20px;
    background-color: ${primaryColor};
    color: #fff;
    font-family: ${primaryFont};
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: ${maxMobile}) { 
     top: 65px;
     line-height: 20px;
    }
    &.hideToaster {
      display: none !important;
    }
    .closeIcon-toaster {
      position: absolute;
      right: 7px;
      top: 4px;
      width: 20px;
      cursor: pointer;
    }
    .ant-spin {
      .ant-spin-dot {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        .ant-spin-dot-item {
          background-color: #fff;
        }
      }
    }
  }
  .wrap-slider {
    width: 100%;
    flex-flow: row nowrap;
    @media all and (max-width: ${midTablet}) { 
      overflow-y: hidden;
      overflow-x: scroll;
    }
    &.forOverFlow {
      @media all and (max-width: ${maxWidth1300}) { 
        overflow-y: hidden;
        overflow-x: scroll;
      }
    }
    &.overFlowOnMaxWidth {
      overflow-y: hidden;
      overflow-x: scroll;
      ${scrollbarTransparent};
    }
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .hidden-scroll {
    @media all and (max-width: ${maxWidth1300}) {
      ${scrollbarTransparent}
    }
  }
  #fc_frame {
    bottom: 30px !important;
    right: 22px !important;
    z-index: 10 !important;
  }
  .feed-page-tabs {
`;

export default generalStyleCore;
